import dayjs from "dayjs";
import React, { useState } from "react";
import { Tabs } from "antd";

export const getZeitFromMinuten = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const seconds = 0;
  // Erstelle ein Day.js-Objekt mit Stunden, Minuten und Sekunden
  const time = dayjs().hour(hours).minute(remainingMinutes).second(seconds);
  // Formatieren Sie das Zeitobjekt als "HH:mm:ss"
  return time.format("HH:mm:ss");
};

export const getMondayOfWeek = (date) => {
  const currentDate = new Date(date);
  const dayOfWeek = currentDate.getDay(); // 0 (Sonntag) bis 6 (Samstag)
  const diff = currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Anzahl der Tage bis zum Montag
  const monday = new Date(currentDate.setDate(diff));
  return monday;
};
export const getNextSunday = (date) => {
  const currentDate = new Date(date);
  const dayOfWeek = currentDate.getDay(); // 0 (Sonntag) bis 6 (Samstag)

  if (dayOfWeek === 0) {
    // Wenn das gegebene Datum bereits ein Sonntag ist
    return currentDate; // Das gegebene Datum ist ein Sonntag, gib es zurück
  } else {
    const diff = currentDate.getDate() + (7 - dayOfWeek); // Anzahl der Tage bis zum nächsten Sonntag
    const nextSunday = new Date(currentDate.setDate(diff));
    return nextSunday;
  }
};

export const minutenFormatierenHHMM = (minutes) => {
  if (minutes === undefined) return "";
  const hours = Math.floor(minutes / 60);
  const min = minutes % 60;
  return `${hours.toString().padStart(2, "0")}:${min
    .toString()
    .padStart(2, "0")}`;
};

export function getJahresliste() {
  const startJahr = 2008;
  const aktuellesJahr = new Date().getFullYear();
  const jahresliste = [];

  for (let jahr = startJahr; jahr <= aktuellesJahr; jahr++) {
    jahresliste.push(jahr);
  }

  return jahresliste;
}
/*
const onChange = (key) => {
  console.log(key);
};
const items = [
  {
    key: '1',
    label: 'Tab 1',
    children: 'Content of Tab Pane 1',
  },
  {
    key: '2',
    label: 'Tab 2',
    children: 'Content of Tab Pane 2',
  },
  {
    key: '3',
    label: 'Tab 3',
    children: 'Content of Tab Pane 3',
  },
];
*/
export const JahresListeTabs = ({ onChange, Child, tabPosition = "top" }) => {
  const [aktjahr, setAktjahr] = useState(
    window.localStorage.getItem("KontoAktJahr")
  );

  const items = [];
  getJahresliste().map((item, index) => {
    if (Child) items.push({ key: `${item}`, label: item, children: <Child /> });
    else items.push({ key: `${item}`, label: item });
    return null;
  });
  //console.log("items", items);
  const myOnchange = (key) => {
    setAktjahr(key);
    window.localStorage.setItem("KontoAktJahr", key);
    if (onChange) {
      onChange(key);
    }
  };
  //console.log("aktjahr", aktjahr);
  //console.log("items", items);
  return (
    <>
      {/*Letzten {items.length} Buchungsjahre:*/}
      <Tabs
        size="small"
        tabPosition={tabPosition}
        defaultActiveKey={aktjahr}
        //activeKey={aktjahr}
        items={items}
        onChange={myOnchange}
      />
    </>
  );
};



export function DelphiDatumShow({ delphiDatum }) {
  // Delphi-Referenzdatum ist der 1. Januar 1900
  let formatiertesDatum="";
  if (delphiDatum!=null&&delphiDatum!=undefined){
  const delphiReferenzdatum = dayjs('1900-01-01');
  
  // Konvertiere das Datum aus Delphi in dayjs und füge die Anzahl der Tage hinzu
  const jsDatum = delphiReferenzdatum.add(parseInt(delphiDatum-2), 'day');
  
  // Formatieren des Datums
  formatiertesDatum = jsDatum.format('DD.MM.YYYY');}

  return (
    <>
      {formatiertesDatum}
    </>
  );
}
export function DelphiDatumShowText( delphiDatum ) {
  // Delphi-Referenzdatum ist der 1. Januar 1900
  const delphiReferenzdatum = dayjs('1900-01-01');
  // Konvertiere das Datum aus Delphi in dayjs und füge die Anzahl der Tage hinzu
  const jsDatum = delphiReferenzdatum.add(parseInt(delphiDatum-2), 'day');
  // Formatieren des Datums
  return jsDatum.format('DD.MM.YYYY');
}
